/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import urls from "../../api/urls";
import API from "../../api";

import { message, Table, Input, Tooltip } from "antd";
import Smcs_Loader from "../../assests/images/loader-new.gif";
import {
  serialNum,
  capitalize,
  convertDate,
  capitaliseWithHyphen,
} from "../../utils";
import search_icon from "../../assests/images/search-icon.svg";
import { getPremiseId } from "../../utils/worker";

// import useCustomNavigate from "../../../../components/customNavigationHook";
import editIcon from "../../assests/images/edit-logo.svg";
import filter_icon from "../../assests/images/master/sorting-filter.svg";
import EllipsisWithTooltip from "../../components/EllipsisWithToolTip";
import useCustomNavigate from "../../components/customNavigationHook";

function ClientList() {
  const navigate = useCustomNavigate();
  const [inputSearchValue, setInputSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const [tableData, setTableData] = useState([]);
  const [pageNum, setPageNum] = useState(0);
  const premiseId = getPremiseId().split("Bearer ")[1];

  const { GET_CLIENT_MASTER_LIST } = urls;

  useEffect(() => {
    getTableData(pageNum, pageSize);
  }, []);

  const branchId = JSON.parse(localStorage.getItem("selectedCompany")).key;

  const getTableData = async (pageNum, pageSize, search) => {
    setLoading(true);

    let url = `${GET_CLIENT_MASTER_LIST}?pageNum=${pageNum}&pageSize=${pageSize}&filter=${premiseId}&branchId=${branchId}`;

    if (search) {
      url += `&search=${search}`;
    }

    let response = await API.Api(url).getWithUserNPremiseHeader();
    if (response?.status) {
      setLoading(false);
      const res = response?.response?.data;
      setTableData(res);
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network Error");
    }
  };

  const reRoute = (pathName) => {
    navigate(pathName);
  };

  const columns = [
    {
      title: "SI",
      width: 60,
      dataIndex: "sl",
      fixed: "left",
      align: "center",
      render: (a, b, idx) => serialNum(pageSize, pageNum + 1, idx),
    },
    {
      title: "Client Name",
      dataIndex: "clientName",
      key: "clientName",
      width: 150,
      render: (text, b) => formatText(text, 25),
    },

    {
      title: "Department",
      dataIndex: "organizationName",
      key: "organizationName",
      width: 80,
      render: (text, b) => formatText(text, 25),
    },
    {
      title: "Phone Number",
      dataIndex: "primaryNum",
      key: "primaryNum",
      width: 90,
      render: (text, b) => formatText(text, 25),
    },

    {
      title: "Email",
      dataIndex: "emailId",
      key: "emailId",
      width: 110,
      render: (text, b) => formatText(text, 25),
    },
    {
      title: "Contact Person",
      dataIndex: "contactPersonName",
      key: "contactPersonName",
      width: 110,
      render: (text, b) => formatText(text, 25),
    },

    {
      title: "Address",
      dataIndex: "addressline1",
      key: "addressline1",
      width: 130,
      // ellipsis: true,
      // render: (text, record) => (
      //   <span>
      //     {capitaliseWithHyphen(
      //       `${text || ""} ${record?.city || ""} ${record?.state || ""} ${
      //         record?.pincode || ""
      //       }`
      //     )}
      //   </span>
      // ),
      render: (text, record) =>
        formatText(
          `${text || ""} ${record?.city || ""} ${record?.state || ""} ${
            record?.pincode || ""
          }`,
          30
        ),
    },

    {
      title: "Created Date",
      dataIndex: "createDate",
      key: "createDate",
      width: 80,
      render: (text, record) => text?.split(" ")?.[0] || "N/A",
    },
  ];

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const formatText = (name, charLength = 15) => {
    if (!name) return "N/A";
    return (
      <>
        {name?.length > charLength ? (
          <Tooltip title={name} placement="bottom">
            {name?.length > charLength
              ? `${name?.substring(0, charLength)}..`
              : name}
          </Tooltip>
        ) : (
          name
        )}
      </>
    );
  };

  const debounceTimeout = useRef(null);

  function handlePageChange(pagenum, pagesize) {
    window.scrollTo(0, 0);
    setPageNum(pagenum - 1);
    setPageSize(pagesize);

    getTableData(pagenum - 1, pagesize, inputSearchValue);
  }

  const onSearch = (e) => {
    const currValue = e.target.value;
    setPageNum(0);
    setPageSize(pageSize);
    setInputSearchValue(currValue);
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(async () => {
      getTableData(0, 20, currValue);
    }, 500);
  };

  return (
    <div className="master-main-container lead-client-approval-list  ml-1">
      <div className="align-center">
        <div className="text-right p-05">
          <Input
            placeholder="Search"
            bordered
            onChange={onSearch}
            style={{ borderRadius: "5px", height: "35px", width: "200px" }}
            suffix={<img src={search_icon} />}
            // value={inputSearchValue}
          />
        </div>
      </div>

      <Table
        className="table-head-sticky"
        loading={{
          indicator: (
            <img
              src={Smcs_Loader}
              style={{ height: "100px", width: "100px" }}
            />
          ),
          spinning: loading,
        }}
        columns={columns}
        dataSource={tableData?.clientList}
        pagination={{
          pageSize: pageSize,
          current: pageNum + 1,
          total: tableData?.totalCount,
          itemRender: itemRender,
          onChange: handlePageChange,
        }}
      />
    </div>
  );
}

export default ClientList;
